import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { InfoDialogComponent }  from '@trivelope/triv-ui-tools-lib';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentExchangeCategory } from 'src/app/classes/document-exchange';
import { DocumentExchangeService } from 'src/app/services/document-exchange.service';



@Component({
	selector: 'app-document-exchange-management',
	templateUrl: './document-exchange-category-management.component.html',
	styleUrls: [ '../management-interface.css' ],
	animations: [
		trigger('detailExpand', [
			state('collapsed', style({height: '0px', minHeight: '0'})),
			state('expanded', style( {height: '*'} )),
			transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
		]),
	],
})
export class DocumentExchangeCategoryManagementComponent implements OnInit {


	elements: DocumentExchangeCategory[] = [];
	dataSource: MatTableDataSource<DocumentExchangeCategory> = new MatTableDataSource( this.elements );
	columnsDisplayed: string[] = [ 'name' ];
	expandedElement = new DocumentExchangeCategory();
	expandedElementPrev = new DocumentExchangeCategory();

	bLoading = true;
	bLoadingError = false;
	bDeleting = false;


	constructor(
		private matDialog: MatDialog,
		private documentExchangeService: DocumentExchangeService
	) {}


	ngOnInit() {

		this.refreshList();

	}


	private refreshList() {

		this.bLoading = true;
		this.documentExchangeService.getDocumentExchangeCategories().subscribe( categories => {

			this.bLoading = false;
			if( !categories ) {
				this.bLoadingError = true;
			}
			else {
				this.bLoadingError = false;

				this.elements = categories;
				this.dataSource.data = this.elements;
				this.sortList();
			}

		});

	}

	clickOnRow( element: DocumentExchangeCategory ) {
		this.expandedElementPrev = this.expandedElement;
		this.expandedElement = (this.expandedElement === element) ? new DocumentExchangeCategory() : element;
	}

	applyFilter( event: Event ) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();

	}

	showCreationDialog() {

		this.matDialog.open( DocumentExchangeCategoryCreatorDialog, {
			maxHeight: '90vh',
		}).afterClosed().subscribe( () => {
			this.refreshList();
		});

	}

	sortList() {
		this.elements.sort( (a,b) =>
			a.name.toLocaleLowerCase().localeCompare(
				b.name.toLocaleLowerCase()
			)
		);
		this.dataSource.data = this.elements;
	}

	clicDelete( element: DocumentExchangeCategory ) {

		this.bDeleting = true;
		this.documentExchangeService.deleteDocumentExchangeCategory( element.id ).subscribe( b => {

			this.bDeleting = false;
			if( b ) {

				const i = this.elements.findIndex( r => r.id === element.id );
				if( i == -1 ) return;

				this.elements.splice( i, 1 );
				this.sortList();

			}
			else {

				this.matDialog.open( InfoDialogComponent, {
					data: { title: 'Fehler', message: 'Beim Löschen der Kategorie ist ein Fehler aufgetreten' }
				});

			}

		});

	}

}



@Component( {
	selector: 'document-exchange-category-creator-dialog',
	template: `
		<div style="display: flex; flex-flow: column nowrap; gap: 2em;">
			<div style="display: flex; flex-flow: row wrap; gap: 1em; color: var(--mainColor)">
				<mat-icon>group_work</mat-icon>
				<span style="font-size: large">Neue Kategorie</span>
			</div>
			<app-document-exchange-category-editor (done)="creationDone()" />
		</div>
	`
})
export class DocumentExchangeCategoryCreatorDialog {

	constructor(
		public dialogRef: MatDialogRef<DocumentExchangeCategoryCreatorDialog>,
	) {}

	creationDone() {
		this.dialogRef.close();
	}

}
